import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import Box from "@mui/material/Box";
import HorizontalSteps from "./horizontal-stepper/HorizontalSteps";
import VerticalSteps from "./vertical-stepper/VerticalStepper";
import {IconButton, useMediaQuery} from "@mui/material";
import {ExpandCircleDownOutlined} from "@mui/icons-material";
import {RoutePaths} from "../../../util/constants";
import {RootState, useAppSelector} from "../../../store";
import useHowItWorksJsonLd from "./useHowItWorksJsonLd";
import React from "react";
import {Link as RouterLink} from "react-router-dom";

const HowItWorks = () => {
    const {t} = useTranslation()
    const matches = useMediaQuery('(min-width:725px)');
    const homeSteps = useAppSelector((state: RootState) => state.homeReducer.content.steps)
    const {content} = useHowItWorksJsonLd(homeSteps)

    return (
        <Box mt="120px">
            <script
                type="application/ld+json">
                {JSON.stringify(content)}
            </script>
            <Typography
                variant="h4"
                color="primary"
                fontWeight={600}
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                }}
            >
                {t('how_it_works')}
                <IconButton
                    color="primary"
                    size="small"
                    component={RouterLink}
                    to={RoutePaths.HOW_IT_WORKS}
                    sx={{ml: 1}}
                >
                    <ExpandCircleDownOutlined sx={{transform: 'rotate(-90deg)'}}/>
                </IconButton>
            </Typography>

            {matches ?
                <HorizontalSteps steps={homeSteps}/> :
                <VerticalSteps steps={homeSteps}/>}
        </Box>
    )
}

export default HowItWorks
